import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/Logo-dark.svg")